module.exports = __webpack_public_path__ + "static/Logo_7-9e773a895190a2c2dfe7aae076789098.png";